import React, { memo } from 'react';
import classnames from 'classnames';
import { ReactComponentLike } from 'prop-types';

import AgGrid from '../../shared/agGrid/agGrid.component';
import { adminColumnSharedFields } from '../../shared/columnDefinitions';
import { useApplyFiltersInitialValue } from '../../scenarios/shared/applyFiltersInitialValue';
import { ColDef, GridOptions } from 'ag-grid-community';


type ViewGridProps<T extends Record<string, unknown>> = {
  adminColumnRenderer?: React.ElementType | ReactComponentLike,
  adminFieldName?: string,
  className?: string,
  columnDefs: ColDef[],
  data: T[],
  isLoading?: boolean,
  shouldDisplayAdminColumn?: boolean,
  onGridReady?: GridOptions['onGridReady'],
  initialFilters?: Record<string, unknown>,
}

const ViewGrid = <T extends Record<string, unknown>>({
  adminColumnRenderer,
  adminFieldName = '',
  className,
  columnDefs,
  data,
  isLoading,
  shouldDisplayAdminColumn,
  onGridReady,
  initialFilters,
}: ViewGridProps<T>) => {
  const adminColumn = {
    field: adminFieldName,
    valueGetter: ({ data }: T) => data,
    cellRenderer: adminColumnRenderer,
    ...adminColumnSharedFields,
  };
  const onFirstDataRendered = useApplyFiltersInitialValue(initialFilters);

  const columnDefinitions = [
    ...(shouldDisplayAdminColumn ? [adminColumn] : []),
    ...columnDefs,
  ];
  return (
    <div className={classnames(className, 'page-content-container')}>
      <div className="ag-theme-bootstrap">
        <AgGrid
          columnDefs={columnDefinitions}
          rowData={data}
          withSearchBar
          isGridLoading={isLoading}
          onGridReady={onGridReady}
          onFirstDataRendered={onFirstDataRendered}
        />
      </div>
    </div>
  );
};

export default memo(ViewGrid);
